import { render, staticRenderFns } from "./AcreditacionesPendientes.vue?vue&type=template&id=67c6da87&"
import script from "./AcreditacionesPendientes.vue?vue&type=script&lang=js&"
export * from "./AcreditacionesPendientes.vue?vue&type=script&lang=js&"
import style0 from "./AcreditacionesPendientes.vue?vue&type=style&index=0&id=67c6da87&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports